module.exports = new __parcel__URL__("apply_k_faq_closed_btn_zh-tw.8a6e46ba.webp").toString();